// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__11Lqc","upload":"Small_upload__12PwT","imageWrap":"Small_imageWrap__2YbmB","removeBtn":"Small_removeBtn__27yi6"};